/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const pipelineStageDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	position: z.number(),
	locked: z.boolean().default(false),
	type: z.string().nullable(),
})

export type PipelineStageDataSchema = z.infer<typeof pipelineStageDataSchema>
